import { toast } from "react-toastify"

export const showNotification = (type, content, op) => {
    const tempOp = {
        position        : "top-right",
        autoClose       : 5000,
        hideProgressBar : false,
        closeOnClick    : true,
        pauseOnHover    : true,
        draggable       : true,
        ...op
    }
    if (type){
        toast[type](content, tempOp)
    } else {
        toast(content, tempOp)
    }
}

export const randomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min
}

export const copyToClipboard = (string) => {
    let textarea = null
    let result = null

    try {
        textarea = document.createElement("textarea")
        textarea.setAttribute("readonly", true)
        textarea.setAttribute("contenteditable", true)
        textarea.style.position = "fixed" // prevent scroll from jumping to the bottom when focus is set.
        textarea.value = string

        document.body.appendChild(textarea)

        textarea.focus()
        textarea.select()

        const range = document.createRange()
        range.selectNodeContents(textarea)

        const sel = window.getSelection()
        sel.removeAllRanges()
        sel.addRange(range)

        textarea.setSelectionRange(0, textarea.value.length)
        result = document.execCommand("copy")
    } catch (err){
        console.error(err)
        result = null
    } finally {
        document.body.removeChild(textarea)
    }

    // manual copy fallback using prompt
    if (!result){
        const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0
        const copyHotkey = isMac ? "⌘C" : "CTRL+C"
        result = prompt(`Press ${copyHotkey}`, string) // eslint-disable-line no-alert
        if (!result){
            return false
        }
    }

    return true
}

export const getTextByShadow = (shadow) => {
    const { is_biggest_num, indexes } = shadow
    let text = ""
    indexes.sort((a, b) => a - b)
    const temp = indexes.reduce((str, item) => (str += ` ${item + 1}`), "")
    text += temp
    if (is_biggest_num){
        text += " lớn ăn"
    } else {
        text += " bé ăn"
    }

    return text
}

export const getPointBySeriAndShadow = (seri, shadow) => {
    let point = 0
    const { indexes } = shadow
    indexes.forEach((index) => {
        point += Number(seri[index])
    })
    point = point % 10

return point
}

export const loadImage = (src) => {
    return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = src
    })
}